import { useState } from 'react';
import dynamic from 'next/dynamic';

import Skeleton from 'antd/es/skeleton';
import FontAwesomeIcon from './FontAwesomeIcon';

const ReactPlayer = dynamic(() => import('react-player/lazy'), { ssr: false });
import { ASSET_BASE_URL } from '../constants';
const MAX_MOBILE_WIDTH = 768;

export default function Demo() {
	const [showType, setShowType] = useState('showcase');
	const [loading, setLoading] = useState(true);

	function handlePlayIntro() {
		if (window.innerWidth <= MAX_MOBILE_WIDTH) setShowType('intro_mobile');
		else setShowType('intro_desktop');
	}

	function handleLoadComplete() {
		setLoading(false);
	}

	return (
		<section className="demo">
			<Skeleton.Node loading={loading} style={{ width: '100vw', height: 'auto', minHeight: '48vw' }}>
				{loading && <i className="fas fa-film" style={{ fontSize: 100, color: '#bfbfbf', position: 'absolute' }} />}
				<div className={`video-container ${loading ? '' : 'loaded'}`}>
					<DeviceVideoPlayer showType={showType} onReady={handleLoadComplete} />
				</div>
			</Skeleton.Node>
			{!loading && showType === 'showcase' && (
				<button className="play-demo-btn" onClick={handlePlayIntro}>
					FacilityBot 4 Min Overview
					<FontAwesomeIcon name={'fas fa-play'} />
				</button>
			)}
		</section>
	);
}

const DeviceVideoPlayer = ({ showType, onReady }) => {
	if (showType === 'showcase') {
		return (
			<ReactPlayer
				className="react-player"
				playing
				playsinline
				loop
				controls={false}
				pip={false}
				stopOnUnmount={false}
				muted
				volume={0}
				url={`${ASSET_BASE_URL}/videos/quick_system_showcase.webm`}
				width="97%"
				height="97%"
				onReady={onReady}
			/>
		);
	} else if (showType === 'intro_desktop') {
		return (
			<ReactPlayer
				className="react-player desktop-player"
				playing
				controls
				volume={1}
				url={`${ASSET_BASE_URL}/videos/intro_video_nov2024.webm`}
				width="82%"
				height="82%"
			/>
		);
	} else {
		return (
			<ReactPlayer
				className="react-player mobile-player"
				playing
				controls
				volume={1}
				url={`${ASSET_BASE_URL}/videos/intro_video_nov2024.webm`}
				width="99%"
				height="99%"
			/>
		);
	}
};
